<img class="icon" src="{{ iconPath }}" [attr.alt]="alt !== undefined ? alt : null">
